<template>
  <div class="toep-buttons-placeholder">
    <div v-if="showButtons" class="toep-buttons">
      <button
        v-if="!isToeped && userName !== lastToeper && !wouldReachMax"
        @click="$emit('toep')"
      >
        Toep to {{ toepValue + 1 }}
      </button>
      <button v-if="isToeped" @click="$emit('call')">
        Call {{ toepValue }}
      </button>
      <button
        v-if="
          isToeped &&
          player &&
          player.kleineSpeler !== undefined &&
          player.kleineSpeler < 2
        "
        @click="$emit('fold')"
      >
        Fold {{ toepValue }}
      </button>
    </div>
    <div v-if="showVuileWasButton" class="toep-buttons">
      <button v-if="!specialRound" @click="$emit('vuileWas')">Vuile Was</button>
      <button
        v-if="specialRound && player && player.points < maxPoints - 1"
        @click="$emit('playSpecialRound')"
      >
        Play special round
      </button>
    </div>
    <div v-if="showCheckButton" class="toep-buttons">
      <button @click="$emit('checkVuileWas', playerId)">Check</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToepButtons',
  props: {
    showButtons: Boolean,
    showVuileWasButton: Boolean,
    showCheckButton: Boolean,
    isToeped: Boolean,
    userName: String,
    lastToeper: String,
    wouldReachMax: Boolean,
    toepValue: Number,
    player: Object,
    specialRound: Boolean,
    maxPoints: Number,
    playerId: String,
  },
  emits: [
    'toep',
    'call',
    'fold',
    'vuileWas',
    'playSpecialRound',
    'checkVuileWas',
  ],
}
</script>

